import { Button } from "@/shared/components/ui/button";
import { Plus } from "lucide-react";
import { v4 } from "uuid";
import { useEffect } from "react";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { useVbsDocumentationAddItemMutation } from "@/services/backend/vbs/work-orders/api/documentation-api";

export function AddItemButton({
  documentationId,
  disabled = false,
}: {
  documentationId: string;
  disabled?: boolean;
}) {
  const [add, { isLoading, error, isSuccess, reset }] =
    useVbsDocumentationAddItemMutation();
  const { toast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      reset();
    }
    if (error) {
      toast({
        variant: "destructive",
        ...parseRTKQueryError(error),
      });
    }
  }, [isSuccess, error, reset, toast]);

  const onClick = () => {
    if (isLoading) {
      return;
    }
    const newID = v4();
    add({
      id: documentationId,
      itemId: newID,
    });
  };

  return (
    <Button
      className="flex items-center space-x-2"
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      <Plus />
    </Button>
  );
}
